<template>
  <div class="antialiased">
    <Sidebar />

    <div class="page">
      <Header :disabledSearch="true" />

      <div class="content">
        <div class="container pos-relative">
          <!-- Page title -->
          <div class="page-header">
            <div class="row d-flex justify-content-between">
              <div class="col-auto"> 
                <h2 class="page-title">Import Order SAN</h2>
              </div>
              <div class="col-auto">
                <div
                  class="alert"
                  :class="available ? 'alert-info' : 'alert-danger'"
                >
                  <b> <i class="fe fe-info mr-1"></i> SYARAT UPLOAD !</b> <br />
                  Format file harus .csv
                </div>
              </div>
            </div>
          </div>
          <div>
            <transition name="slide-fade-x">
              <div class="time-convert" v-if="isFinish">
                <div
                  class="text-muted"
                  v-html="
                    'Estimasi waktu konversi ' +
                    (timeFinish >= 60
                      ? parseInt(timeFinish / 60) +
                        ' menit ' +
                        (timeFinish - 60 * parseInt(timeFinish / 60)) +
                        ' detik'
                      : timeFinish + ' detik')
                  "
                ></div>
              </div>
            </transition>
            <div class="frame-upload" @dragover.prevent @drop.prevent="_drop">
              <div class="file-control" v-if="files.length > 0">
                <i
                  class="fe fe-chevron-left nav-left"
                  v-if="file.index > 0"
                  @click="_prevFile"
                ></i>
                <i
                  class="fe fe-chevron-right nav-right"
                  v-if="file.index < files.length - 1"
                  @click="_nextFile"
                ></i>
              </div>

              <div
                class="input-file"
                @click="isSubmit ? false : $refs.file.click()"
                :class="isSubmit ? 'active' : ''"
              >
                <input
                  type="file"
                  class="d-none"
                  accept=".csv"
                  ref="file"
                  @change="_onFile"
                />

                <transition name="slide-fade-y">
                  <div v-if="file.file != null">
                    <div class="img">
                      <span v-html="file.size"></span>
                      <img :src="asset('csv.png')" alt="" />
                    </div>
                    <div v-html="file.name" class="mt-2"></div>
                    <div
                      v-if="files.length > 1"
                      v-html="
                        file.index + 1 + ' dari ' + files.length + ' file'
                      "
                    ></div>
                  </div>
                </transition>

                <div v-if="file.file == null && !hasUploaded">
                  <div class="mb-3"><i class="fe fe-upload"></i></div>
                  <div style="letter-spacing: 2px">
                    UPLOAD FILE CSV <br />
                    ATAU DRAG & DROP DISINI
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Message :config.sync="message.config" />
    <FilePreview :config.sync="filePreview.config" :csvHeaders="csvHeaders" :csvData="csvData" :resetData="_resetData" :importData="_importData" />
    <FailedImported :config.sync="failedImported.config" :csvHeaders="csvHeaders" :csvData="errors" :resetData="_resetData" :exportData="_exportData" />
    <InvalidDate :config.sync="invalidDate.config" :invalidDates="invalidDates" :resetData="_resetData" />
  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import Papa from "papaparse";
import FailedImported from "./modals/failed-imported.vue";
import FilePreview from "./modals/file-preview.vue";
import InvalidDate from "./modals/invalid-date.vue";
import Message from "./modals/message.vue";

export default {
  name: "ImportOrderSan",
  components: { Message, FilePreview, FailedImported, InvalidDate },

  data() {
    return {
      auth: {},
      ...this._getInitialState(),
    };
  },

  mixins: [helper],

  methods: {
    _getInitialState() {
      return {
        file: {
          file: null,
          name: null,
          size: null,
          index: 0,
        },
        csvHeaders: [],
        csvData: [],
        jsonData: {},
        invalidDates: [],
  
        message: {
          config: { view: false },
        },
  
        filePreview: {
          config: { 
            view: false,
          },
        },

        failedImported: {
          config: { 
            view: false,
          },
        },
        
        invalidDate: {
          config: { 
            view: false,
          },
        },
        
        files: [],
        hasUploaded: false,
        isSubmit: false,
        interval: null,
        time: 0,
        timeFinish: 0,
        available: true,
        isFinish: false,
        errors: [],
      };
    },
    _onFile(e, params) {
      const file = params == null ? e.target.files[0] : params.files[0];
      const allowed = ["csv"];

      if (!allowed.includes(file.name.split(".").pop().toLowerCase())) {
        this.toast("Format file tidak valid");
        return;
      }

      this.file.file = file;
      this.file.name = file.name;
      this.file.size = this.formatBytes(file.size);

      const reader = new FileReader();
      reader.onload = (event) => {
        const text = event.target.result;
        const delimiter = text.includes(";") ? ";" : ",";
        const numberHeaders = ["Quantity", "QTY 1", "QTY 2", "Harga Satuan", "Jumlah Kotor", "Disc 1 (Rp)", "Disc 2 (Rp)", "Disc 3 (Rp)", "Disc 4 (Rp)", "Total Diskon", "Jumlah", "Jumlah PPN", "Jumlah Total", "Jumlah HPP"];
        const stringHeaders = ["KTP", "NPWP"];
        const dateHeaders = ["Tgl Faktur", "Doc Date", "SO Date", "Shipdate"];

        Papa.parse(text, {
          delimiter,
          header: false,
          skipEmptyLines: true,
          complete: (result) => {
            if (result.data.length < 2) {
              alert("Invalid CSV file.");
              this._resetData();
              return;
            }

            if (result.data[0].length === 1) {
              this.csvHeaders = result.data[0][0].split(delimiter).map(header => header.trim());
            } else {
              this.csvHeaders = result.data[0].map(header => header.trim());
            }

            const snakeCaseHeaders = this.csvHeaders.map(this._toSnakeCase);

            this.csvData = result.data.slice(1).map((row, indexRow) => {
              let obj = {};
              if (row.length === 1) {
                const values = row[0].split(delimiter).map(value => value.trim());
                this.csvHeaders.forEach((header, index) => {
                  if (numberHeaders.includes(header)) {
                    obj[header] = this._cleanValue(values[index]);
                  } else if (stringHeaders.includes(header)) {
                    obj[header] = this._cleanLongValue(values[index]);
                  } else if (dateHeaders.includes(header)) {
                    if (!this._isValidDateFormat(values[index])) {
                      this.invalidDates.push({ row: indexRow, column: header, value: values[index] });
                    }
                    obj[header] = values[index];
                  } else {
                    obj[header] = values[index] || "";
                  }
                });
              } else {
                this.csvHeaders.forEach((header, index) => {
                  if (numberHeaders.includes(header)) {
                    obj[header] = this._cleanValue(row[index]);
                  } else if (stringHeaders.includes(header)) {
                    obj[header] = this._cleanLongValue(row[index]);
                  } else if (dateHeaders.includes(header)) {
                    if (!this._isValidDateFormat(row[index])) {
                      this.invalidDates.push({ row: indexRow, column: header, value: row[index] });
                    }
                    obj[header] = row[index];
                  } else {
                    obj[header] = row[index] ? row[index].trim() : "";
                  }
                });
              }

              return obj;
            });

            if (this.invalidDates.length > 0) {
              this.invalidDate.config.view = true;
              return;
            }

            this.jsonData = this.csvData.map(row => {
              let obj = {};
              this.csvHeaders.forEach((header, index) => {
                let snakeKey = snakeCaseHeaders[index];
                obj[snakeKey] = row[header] ? this._cleanValue(row[header]) : "";
              });

              return obj;
            });

            this.filePreview.config.view = true;           
            this.hasUploaded = true;
          },
        });
      };
      reader.readAsText(file);
    },

    /**
    * Function to validate if a date string is in DD-MM-YYYY and D-M-YYYY format.
    */
    _isValidDateFormat(value) {
      if (!value) return false;
      const regex = /^(0?[1-9]|[12][0-9]|3[01])-(0?[1-9]|1[0-2])-(\d{4})$/;
      return regex.test(value);
    },
    
    _toSnakeCase(str) {
      let formatted = str.toLowerCase().trim();

      let percentageMatch = formatted.match(/^disc\s*(\d+)\s*\(%\)$/i);
      if (percentageMatch) {
        return `disc_${percentageMatch[1]}_percentage`;
      }

      let valueMatch = formatted.match(/^disc\s*(\d+)\s*\(rp\)$/i);
      if (valueMatch) {
        return `disc_${valueMatch[1]}_value`;
      }

      return formatted.replace(/\s+/g, "_").replace(/[^a-z0-9_]/g, "");
    },
    
    _cleanValue(value) {
      if (typeof value === "string") {
        let cleaned = value.trim().replace(/,/g, "");
        return isNaN(cleaned) ? cleaned : parseFloat(cleaned);
      }
      return value;
    },

    _cleanLongValue(value) {
      if (!value || value.trim() === "") {
        return '';
      }
      
      let formattedValue = value.replace(",", ".");
      
      let number = Number(formattedValue);
      return isNaN(number) ? 0 : number;
    },

    _exportData() {
      const cleanedData = this.errors.map(({ error, ...rest }) => rest);

      const headerMapping = [
        { key: "tipe_trans", label: "TIPE TRANS" },
        { key: "kode_pelanggan", label: "Kode Pelanggan" },
        { key: "nama_pelanggan", label: "Nama Pelanggan" },
        { key: "alamat1", label: "Alamat1" },
        { key: "alamat2", label: "Alamat2" },
        { key: "kota", label: "Kota" },
        { key: "tgl_faktur", label: "Tgl Faktur" },
        { key: "no_faktur", label: "No. Faktur" },
        { key: "doc_date", label: "Doc Date" },
        { key: "doc_no", label: "Doc No" },
        { key: "no_so", label: "No. SO" },
        { key: "so_date", label: "SO Date" },
        { key: "no_item", label: "No Item" },
        { key: "deskripsi_item", label: "Deskripsi Item" },
        { key: "packing", label: "Packing" },
        { key: "satuan1", label: "Satuan1" },
        { key: "konversi", label: "Konversi" },
        { key: "qty_2", label: "QTY 2" },
        { key: "qty_1", label: "QTY 1" },
        { key: "quantity", label: "Quantity" },
        { key: "harga_satuan", label: "Harga Satuan" },
        { key: "jumlah_kotor", label: "Jumlah Kotor" },
        { key: "disc_1_percentage", label: "Disc 1 (%)" },
        { key: "disc_2_percentage", label: "Disc 2 (%)" },
        { key: "disc_3_percentage", label: "Disc 3 (%)" },
        { key: "disc_4_percentage", label: "Disc 4 (%)" },
        { key: "disc_1_value", label: "Disc 1 (Rp)" },
        { key: "disc_2_value", label: "Disc 2 (Rp)" },
        { key: "disc_3_value", label: "Disc 3 (Rp)" },
        { key: "disc_4_value", label: "Disc 4 (Rp)" },
        { key: "total_diskon", label: "Total Diskon" },
        { key: "jumlah", label: "Jumlah" },
        { key: "jumlah_ppn", label: "Jumlah PPN" },
        { key: "jumlah_total", label: "Jumlah Total" },
        { key: "jumlah_hpp", label: "Jumlah HPP" },
        { key: "kode_supplier", label: "Kode Supplier" },
        { key: "kode_sales", label: "Kode Sales" },
        { key: "nama_sales", label: "Nama Sales" },
        { key: "type_outlet", label: "Type Outlet" },
        { key: "termin", label: "Termin" },
        { key: "npwp", label: "NPWP" },
        { key: "ktp", label: "KTP" },
        { key: "item_category", label: "Item Category" },
        { key: "warehouse", label: "Warehouse" },
        { key: "distributor", label: "Distributor" },
        { key: "level_harga", label: "Level Harga" },
        { key: "shipname", label: "Shipname" },
        { key: "shipdate", label: "Shipdate" }
      ];

      const csv = Papa.unparse({
        fields: headerMapping.map(h => h.label),
        data: cleanedData.map(item =>
          headerMapping.map(h => item[h.key] || "")
        ),
      });

      const now = new Date();
      const formattedDateTime = now.toISOString().replace(/[-T:]/g, "").slice(0, 15);
      const filename = `exported_data_${formattedDateTime}.csv`;
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    _importData() {
      this.filePreview.config.view = false;      
      this.isSubmit = true;
      this.isFinish = false;

      let self = this;
      this.time = 1;
      this.timeFinish = 1;

      this.interval = setInterval(function () {
        self.time = self.time + 1;
        self.timeFinish = self.timeFinish + 1;
      }, 1000);

      this.axios
        .post("external_app/san/import-order", this.jsonData)
        .then((res) => {
          clearInterval(this.interval);
          this.isSubmit = false;
          
          if (res.data.errors.length > 0) {
            this.errors = res.data.errors;
            this.failedImported.config.view = true;
          } else {
            this._resetData();
          }

          this.toast(res.data.message);
          this.isFinish = true;
        })
        .catch((err) => {
          clearInterval(this.interval);
          this._resetData();
          this.onError(err);
          this.isFinish = true;
          this.message.config.view = true;
        });
    },

    _drop(e) {
      e.preventDefault();
      const file = e.dataTransfer.files[0];
      this._onFile({ target: { files: [file] } });
    },

    _resetData() {
      Object.assign(this.$data, this._getInitialState());
      if (this.$refs.file) {
        this.$refs.file.value = "";
      }
    },

    _dragOver(e) {},
    refresh() {
      window.location.reload();
    },
  },

  mounted() {
    this.auth = JSON.parse(localStorage.user);
  },
};
</script>

<style lang="scss" src="./import-order-san.scss" scoped/>